import {
  IBienLaiThu,
  IBienLaiThuViewModel,
} from "../../../model/respone/bien-lai/IBienLaiThu";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { ILuyKeSinhVienRespone } from "../../../model/respone/report/ITongHopSinhVienRespone";
import { ITongHopSinhVienActionTypes } from "../../action-types/report/ITongHopSinhVienActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import {
  IBienLaiLuyKeSinhVien,
  ITongHopSinhVienReducer,
} from "../../reducer-model/report/ITongHopSinhVienReducer";

const iniState: ITongHopSinhVienReducer = {
  luyKeSinhViens: [],
  bienLaiLuyKeSinhViens: [],
  mucThuLuyKeSinhViens: [],
};
export const tongHopSinhVienReducer = (
  state: ITongHopSinhVienReducer = iniState,
  action: ITongHopSinhVienActionTypes
): ITongHopSinhVienReducer => {
  switch (action.type) {
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_SO_LIEU_START":
      return {
        ...state,
        luyKeSinhViens: [
          ...state.luyKeSinhViens?.filter((g) => g.id_sv !== action.payload),
          {
            id_sv: action.payload,
            status: eReducerStatusBase.is_loading,
          } as ILuyKeSinhVienRespone,
        ],
      };
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_SO_LIEU_SUCCESS":
      return {
        ...state,
        luyKeSinhViens: state.luyKeSinhViens.map((g) => {
          if (g.id_sv === action.payload.id_sv) {
            return {
              ...g,
              ...action.payload,
              status: eReducerStatusBase.is_completed,
            };
          }
          return g;
        }),
      };
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_SO_LIEU_ERROR":
      return {
        ...state,
        luyKeSinhViens: state.luyKeSinhViens.map((g) => {
          if (g.id_sv === action.payload) {
            return {
              ...g,
              status: eReducerStatusBase.is_completed,
            };
          }
          return g;
        }),
      };
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_BIEN_LAI_START":
      return {
        ...state,
        bienLaiLuyKeSinhViens: [
          ...state.bienLaiLuyKeSinhViens.filter(
            (g) => g.id_sv !== action.payload
          ),
          {
            id_sv: action.payload,
            status: eReducerStatusBase.is_loading,
          } as IBienLaiLuyKeSinhVien<IBienLaiThuViewModel[]>,
        ],
      };
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_BIEN_LAI_SUCCESS":
      return {
        ...state,
        bienLaiLuyKeSinhViens: state.bienLaiLuyKeSinhViens.map((g) => {
          if (g.id_sv === action.payload.id_sv) {
            return {
              ...g,
              ...action.payload,
              status: eReducerStatusBase.is_completed,
            };
          }
          return g;
        }),
      };
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_BIEN_LAI_ERROR":
      return {
        ...state,
        bienLaiLuyKeSinhViens: state.bienLaiLuyKeSinhViens.map((g) => {
          if (g.id_sv === action.payload) {
            return {
              ...g,
              status: eReducerStatusBase.is_completed,
            };
          }
          return g;
        }),
      };
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_MUC_THU_START":
      return {
        ...state,
        mucThuLuyKeSinhViens: [
          ...state.mucThuLuyKeSinhViens.filter(
            (g) => g.id_sv !== action.payload
          ),
          {
            id_sv: action.payload,
            status: eReducerStatusBase.is_loading,
          } as IBienLaiLuyKeSinhVien<IMucThuKhacSinhVienViewModel[]>,
        ],
      };
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_MUC_THU_SUCCESS":
      return {
        ...state,
        mucThuLuyKeSinhViens: state.mucThuLuyKeSinhViens.map((g) => {
          if (g.id_sv === action.payload.id_sv) {
            return {
              ...g,
              ...action.payload,
              status: eReducerStatusBase.is_completed,
            };
          }
          return g;
        }),
      };
    case "TONG_HOP_SINH_VIEN_LOAD_LUY_KE_MUC_THU_ERROR":
      return {
        ...state,
        mucThuLuyKeSinhViens: state.mucThuLuyKeSinhViens.map((g) => {
          if (g.id_sv === action.payload) {
            return {
              ...g,
              status: eReducerStatusBase.is_completed,
            };
          }
          return g;
        }),
      };
    default:
      return state;
  }
};
